module.exports = __webpack_public_path__ + "img/badge-list-thumb-080.26882b96.png";